<template>
  <el-dialog title="上传价格表照片" :visible.sync="dialogVisible" center :show-close="true" width="630px" class="themeDialog">
    <div class="formBox">
      <el-upload class="upload-demo" drag action=" " multiple>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
      </el-upload>
    </div>
    <div slot="footer">
      <button class="cancel" @click="cancel">取消</button>
      <button class="save" @click="save">确定</button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
    }
  },
  methods: {
    show() {
      this.dialogVisible = true;
    },
    cancel() {
      this.dialogVisible = false;
    },
    save() {
      this.dialogVisible = false;
    }
  }
}
</script>
<style  scoped>
/*.formBox {*/
  /*width: 360px;*/
  /*margin: 0 auto;*/
  /*/deep/ .el-form-item {*/
    /*margin-bottom: 24px;*/
    /*&:last-child {*/
      /*margin-bottom: 0;*/
    /*}*/
  /*}*/

  /*.uploadBtn {*/
    /*@include btnCommon(primaryPlain, 36px, 92px, 4px, 12px);*/
  /*}*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/views/childComp/GrassAdd.vue